import React from 'react'
import { ModeTypes } from 'common/Enums'
import { ReactComponent as AvailableIcon } from 'assets/svg/shared/available.svg'
import { ReactComponent as UnavailableIcon } from 'assets/svg/shared/do_not_disturb.svg'

export const ModeDropdownConfig = [
    {
        id: ModeTypes.Available,
        icon: <AvailableIcon width={18} height={18} />,
        name: 'available'
    },
    {
        id: ModeTypes.Unavailable,
        icon: <UnavailableIcon width={18} height={18} />,
        name: 'unavailable'
    }
]
